import { Component, OnInit } from '@angular/core';

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
})
export class FooterComponent implements OnInit {
  constructor() {}
  currentYear :any

  ngOnInit() {
    this.currentYear = new Date().getFullYear()
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.ts